'use client';

import { __awaiter, __generator } from '../../../_virtual/_tslib.js';
import React__default, { useState, useEffect, Suspense } from 'react';
import { useNotifyStore } from '../../context/index.js';
import { NOTIFY_ACTION } from '../../context/action.js';
import { Background, DropdownContainerWrapper, DropdownContainerBodyWrapper, HeaderTitle, NotifyIcon, TitleContent, CloseIcon, NotifyBadge } from './NotificationMain.css.js';
import ReactDOM from 'react-dom';
import { getJobInvitationNotifications } from '../../services/jobInvitation.js';
import { isPhone } from '../../helpers/utils.js';
import { ELanguage } from '../../../Utils/constants.js';
import '../../../Images/AddIcon/index.js';
import '../../../Images/AddOutlinedIcon/index.js';
import '../../../Images/Trash/index.js';
import '../../../Images/Pencil/index.js';
import '../../../Images/ArrowRoundedLeft/index.js';
import '../../../Images/ArrowRoundedRight/index.js';
import '../../../Images/AwardsIcon/index.js';
import '../../../Images/BonusIcon/index.js';
import '../../../Images/CanteenIcon/index.js';
import '../../../Images/CheckTagIcon/index.js';
import CloseIcon$1 from '../../../Images/CloseIcon/index.js';
import '../../../Images/CommercialIcon/index.js';
import '../../../Images/CompanySizeIcon/index.js';
import '../../../Images/ContactIcon/index.js';
import '../../../Images/CopyIcon/index.js';
import '../../../Images/DefaultAvatar/index.js';
import '../../../Images/DangerIcon/index.js';
import '../../../Images/ExternalLinkIcon/index.js';
import '../../../Images/FacebookIcon/index.js';
import '../../../Images/ForwardIcon/index.js';
import '../../../Images/HealthcarePlanIcon/index.js';
import '../../../Images/HeartIcon/index.js';
import '../../../Images/HeartOutlineIcon/index.js';
import '../../../Images/HideIcon/index.js';
import '../../../Images/KindergartenIcon/index.js';
import '../../../Images/LaptopIcon/index.js';
import '../../../Images/LibraryIcon/index.js';
import '../../../Images/LinkIcon/index.js';
import '../../../Images/LinkedInIcon/index.js';
import '../../../Images/LoadingCircleIcon/index.js';
import '../../../Images/MarkerIcon/index.js';
import '../../../Images/MobileIcon/index.js';
import '../../../Images/PaidLeaveIcon/index.js';
import '../../../Images/SearchIcon/index.js';
import '../../../Images/ShareIcon/index.js';
import '../../../Images/ReportIcon/index.js';
import '../../../Images/StatsIcon/index.js';
import '../../../Images/TeamActivitiesIcon/index.js';
import '../../../Images/ThreeDotIcon/index.js';
import '../../../Images/TrainingIcon/index.js';
import '../../../Images/TransportationIcon/index.js';
import '../../../Images/TrashIcon/index.js';
import '../../../Images/TravelOpportunitiesIcon/index.js';
import { colors } from '../../../Colors/index.js';
import '../../../Images/VerticalMoreIcon/index.js';
import '../../../Images/VoucherIcon/index.js';
import '../../../Images/WowCVIcon/index.js';
import '../../../Images/WorkingLocationIcon/index.js';
import '../../../Images/ZaloIcon/index.js';
import '../../../Images/FacebookLogoIcon/index.js';
import '../../../Images/GoogleLogoIcon/index.js';
import '../../../Images/DragReorderIcon/index.js';
import '../../../Images/CheckIcon/index.js';
import '../../../Images/CircleChecked/index.js';
import '../../../Images/SalaryIcon/index.js';
import '../../../Images/BriefcaseIcon/index.js';
import '../../../Images/GraduationCapIcon/index.js';
import '../../../Images/EnvelopeIcon/index.js';
import '../../../Images/AddFilledIcon/index.js';
import '../../../Images/HomeIcon/index.js';
import '../../../Images/PhoneIcon/index.js';
import '../../../Images/AttachIcon/index.js';
import '../../../Images/FilterIcon/index.js';
import '../../../icons/WarnIcon.js';
import '../../../icons/AccountSettingsIcon.js';
import '../../../icons/DashboardIcon.js';
import '../../../icons/JobAlertsIcon.js';
import '../../../icons/MyCompaniesIcon.js';
import '../../../icons/MyJobsIcon.js';
import '../../../icons/MyProfileIcon.js';
import '../../../icons/ProfileSettingsIcon.js';
import '../../../icons/LanguageIcon.js';
import '../../../icons/BenefitGroupIcons/ActivityIcon.js';
import '../../../icons/BenefitGroupIcons/AwardsIcon.js';
import '../../../icons/BenefitGroupIcons/BonusIcon.js';
import '../../../icons/BenefitGroupIcons/CanteenIcon.js';
import '../../../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../../../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../../../icons/BenefitGroupIcons/LaptopIcon.js';
import '../../../icons/BenefitGroupIcons/LibraryIcon.js';
import '../../../icons/BenefitGroupIcons/MoreIcon.js';
import '../../../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../../../icons/BenefitGroupIcons/PhoneIcon.js';
import '../../../icons/BenefitGroupIcons/TrainingIcon.js';
import '../../../icons/BenefitGroupIcons/TransportationIcon.js';
import '../../../icons/BenefitGroupIcons/TravelIcon.js';
import '../../../icons/BenefitGroupIcons/VoucherIcon.js';
import '../../../icons/BenefitGroupIcons/Physics.js';
import '../../../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../../../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../../../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../../../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../../../icons/AccountCenterGroupIcons/Language.js';
import '../../../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../../../icons/AccountCenterGroupIcons/Lawyer.js';
import '../../../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../../../icons/InfoOverviewGroupIcons/Location.js';
import '../../../icons/InfoOverviewGroupIcons/Education.js';
import '../../../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../../../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../../../icons/InfoOverviewGroupIcons/Admin.js';
import '../../../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../../../icons/InfoOverviewGroupIcons/Address.js';
import '../../../icons/InfoOverviewGroupIcons/Salary.js';
import '../../../icons/InfoOverviewGroupIcons/Gender.js';
import '../../../icons/InfoOverviewGroupIcons/Translator.js';
import '../../../icons/InfoOverviewGroupIcons/Birthday.js';
import '../../../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../../../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../../../icons/MiscGroupIcons/Link.js';
import '../../../icons/MiscGroupIcons/History.js';
import '../../../icons/MiscGroupIcons/Favorite.js';
import '../../../icons/MiscGroupIcons/UnFavorite.js';
import '../../../icons/MiscGroupIcons/ProductDocuments.js';
import '../../../icons/MiscGroupIcons/Star.js';
import '../../../icons/SocialMediaGroupIcons/Facebook.js';
import '../../../icons/SocialMediaGroupIcons/Linkedin.js';
import '../../../icons/SocialMediaGroupIcons/Twitter.js';
import '../../../icons/SocialMediaGroupIcons/Zalo.js';
import '../../../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../../../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../../../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../../../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../../../icons/SocialMediaGroupIcons/Share.js';
import '../../../icons/NavigationGroupIcons/Vertical.js';
import '../../../icons/NavigationGroupIcons/More.js';
import '../../../icons/NavigationGroupIcons/Close.js';
import '../../../icons/NavigationGroupIcons/Expand.js';
import '../../../icons/NavigationGroupIcons/Collapse.js';
import '../../../icons/NavigationGroupIcons/Next.js';
import '../../../icons/NavigationGroupIcons/Back.js';
import '../../../icons/NavigationGroupIcons/ExternalLink.js';
import '../../../icons/NavigationGroupIcons/RightArrow.js';
import '../../../icons/AlertGroupIcons/SuccessIcon.js';
import '../../../icons/AlertGroupIcons/CareerPath.js';
import '../../../icons/AlertGroupIcons/Hot.js';
import '../../../icons/AlertGroupIcons/Urgent.js';
import '../../../icons/FormActionGroupIcons/Exchange.js';
import '../../../icons/FormActionGroupIcons/AddTag.js';
import '../../../icons/RewardsTypeGroupIcons/Hospital.js';
import '../../../Images/DoubleTickIcon/index.js';
import index from '../../../Images/BellIcon/index.js';
import '../../../Images/AiIcon/index.js';
import '../../../Images/MiniAiIcon/index.js';
import '../../../icons/OrderManagementIcon.js';
import '../../../Images/TwinkleLinearGradientIcon/index.js';
import Typography from '../../../Typography/index.js';
import useFloating from '../../../hooks/useFloating/index.js';

// Lazy import
var NotificationBody = React__default.lazy(function () { return import('../NotificationBody/index.js'); });
var MAX_DISPLAY_NOTIFY_COUNT = 9;
var NotificationMain = function () {
    var _a = useNotifyStore(), state = _a.state, firebase = _a.firebase, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isOpen = state.isOpen, notificationCount = state.notificationCount;
    var _b = useState(false), isMounted = _b[0], setMounted = _b[1];
    var isInMobile = isPhone();
    var _c = useFloating({
        placement: 'bottom-end',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: true,
            isFlip: false,
            detectHidden: false
        }
    }), refs = _c.refs, context = _c.context, FloatingPortal = _c.FloatingPortal;
    var onOpenNotification = function () {
        if (isOpen) {
            dispatch({
                type: NOTIFY_ACTION.HIDE
            });
            return;
        }
        firebase.getNotification();
        dispatch({
            type: NOTIFY_ACTION.SHOW
        });
    };
    var onClose = function () {
        dispatch({
            type: NOTIFY_ACTION.HIDE
        });
    };
    var onAnimationEnd = function () {
        if (isOpen) {
            return;
        }
        setMounted(false);
    };
    var fetchJobInvitationNotifications = function () { return __awaiter(void 0, void 0, void 0, function () {
        var responseNotifications;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!((_a = props.config) === null || _a === void 0 ? void 0 : _a.baseMsUrl) || ((_b = props.config) === null || _b === void 0 ? void 0 : _b.baseMsUrl) === '') {
                        return [2 /*return*/];
                    }
                    if (!((_c = props.user) === null || _c === void 0 ? void 0 : _c.accessToken) || ((_d = props.user) === null || _d === void 0 ? void 0 : _d.accessToken) === '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getJobInvitationNotifications({
                            msBaseUrl: (_e = props.config) === null || _e === void 0 ? void 0 : _e.baseMsUrl,
                            accessToken: (_f = props.user) === null || _f === void 0 ? void 0 : _f.accessToken,
                            langCode: (_g = props.langCode) !== null && _g !== void 0 ? _g : ELanguage.VI
                        })];
                case 1:
                    responseNotifications = _h.sent();
                    if (!responseNotifications) {
                        return [2 /*return*/];
                    }
                    dispatch({
                        type: NOTIFY_ACTION.MAP_JOB_INVITATION_NOTIFICATIONS,
                        payload: responseNotifications
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!isOpen) {
            return;
        }
        var onKeyUp = function (e) {
            if (!isOpen) {
                return;
            }
            if (e.key === 'Escape') {
                onClose();
            }
        };
        setMounted(true);
        fetchJobInvitationNotifications();
        window.addEventListener('keyup', onKeyUp);
        return function () {
            window.removeEventListener('keyup', onKeyUp);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    useEffect(function () {
        window.addEventListener('VNW_OPEN_NOTIFICATION', onOpenNotification);
        return function () {
            window.removeEventListener('VNW_OPEN_NOTIFICATION', onOpenNotification);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var dropdownStyle = {
        position: context.position,
        bottom: 0,
        right: 0,
        display: context.isReferenceHidden ? 'none' : 'block',
        zIndex: 201
    };
    var desktopRedDotContainer = typeof document !== 'undefined' ? document.querySelector('#desktopRedDotContainer') : null;
    var mobileRedDotContainer = typeof document !== 'undefined' ? document.querySelector('#mobileRedDotContainer') : null;
    var labelOfNumberNotify = "".concat(notificationCount);
    // If current number of notification is larger than MAX_DISPLAY_NOTIFY_COUNT
    // then we should display it as 'MAX_DISPLAY_NOTIFY_COUNT+'
    if (notificationCount > MAX_DISPLAY_NOTIFY_COUNT) {
        labelOfNumberNotify = "".concat(MAX_DISPLAY_NOTIFY_COUNT, "+");
    }
    if (!labelOfNumberNotify) {
        labelOfNumberNotify = '0';
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(FloatingPortal, { enable: true }, isMounted ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Background, { onClick: onClose }),
            React__default.createElement(DropdownContainerWrapper, { isShow: isOpen, ref: refs.setPopup, style: dropdownStyle, onAnimationEnd: onAnimationEnd },
                React__default.createElement(DropdownContainerBodyWrapper, { isShow: isOpen, isMobile: isInMobile, "data-floating-placement": 'bottom-end' },
                    React__default.createElement(HeaderTitle, null,
                        React__default.createElement(NotifyIcon, null,
                            React__default.createElement(index, null)),
                        React__default.createElement(TitleContent, null,
                            React__default.createElement(Typography, { name: 'title', size: 'large', color: '#000' }, t('Notifications')),
                            React__default.createElement(Typography, { size: 'medium', color: colors.grey[40] }, t('Get notifications for jobs'))),
                        React__default.createElement(CloseIcon, { onClick: onClose },
                            React__default.createElement(CloseIcon$1, null))),
                    React__default.createElement(Suspense, { fallback: React__default.createElement(React__default.Fragment, null) },
                        React__default.createElement(NotificationBody, null)))))) : (React__default.createElement(React__default.Fragment, null))),
        desktopRedDotContainer && notificationCount > 0
            ? ReactDOM.createPortal(React__default.createElement(NotifyBadge, { className: 'custom__red_dot totalNumber' }, labelOfNumberNotify), desktopRedDotContainer)
            : null,
        mobileRedDotContainer && notificationCount > 0
            ? ReactDOM.createPortal(
            // UI change, replace red dot to total notification
            React__default.createElement(NotifyBadge, { className: 'totalNumber' }, labelOfNumberNotify), mobileRedDotContainer)
            : null));
};

export { NotificationMain as default };
//# sourceMappingURL=index.js.map
